import { Button } from "primereact/button";

// The menu of a checklist row: its note and its photo.
const CheckMenu = ({ row, onClickFoto, onClickEditNote }) => {
  return (
    <div className="col-start-start w-full">
      <Button
        className="!row-start-center rounded-none bg-white border-none text-slate-500 gap-3 !pl-5 hover:bg-slate-100 w-[10rem]"
        severity="secondary"
        onClick={(event) => {
          if (onClickEditNote) onClickEditNote(event, row);
        }}
      >
        <i className="pi pi-pencil text-xs"></i>
        <span>Note</span>
      </Button>
      <Button
        className="!row-start-center rounded-none bg-white border-none text-slate-500 gap-3 !pl-5 pr-4 hover:bg-slate-100 w-full"
        onClick={(event) => onClickFoto(event)}
      >
        <i className="pi pi-camera text-xs"></i>
        <span>Foto</span>
      </Button>
    </div>
  );
};

export default CheckMenu;
